import React from 'react'
import Pagination from '../layout/Pagination'
import { canManageProducts } from '../global_context/capabilities/productCapabilities'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import ReactFilter from '../components/inputs/ReactFilterList'
import { Table } from 'react-bootstrap'
import LoadingScreen from '../components/LoadingScreen'

const ProductIndexView = ({
  isFetching,
  title,
  productData,
  filters,
  filterVersion,
  searchInput,
  handleSearch,
  handleEnterSearch,
  resetReactFilters,
  isAnyFilterSelected,
  productFilter,
  handlePaginationClick,
  pagination,
  updateAllSelectedOptions
}) => {
  const showCreateProductPage = () => {
    window.open('/crear_producto', '_blank', 'noopener,noreferrer')
  }

  const showModel = (event) => {
    event.preventDefault()
    const id = event.target.id
    window.open(`/productos/${id}/detalles`, '_blank', 'noopener,noreferrer')
  }

  const handleFilterChange = (identifier, selectedOptions) => {
    updateAllSelectedOptions(identifier, Array.from(selectedOptions))
  }

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  return (
    <>
      <div className="index-header detailed-container">
        <h2 className="text-header-tittle">{title}</h2>
        <div className="index-buttons">
          {canManageProducts() && (
            <button className="text-header-tittle" onClick={showCreateProductPage}>
              Crear producto nuevo
            </button>
          )}
        </div>
      </div>

      <div className="index-table">
        <div className="show-area">
          {!productFilter?.byBrand && !productFilter?.byCategory && (
            <>
              <h4 className="text-sub-title">Filtrar productos por:</h4>
              <div className="filters-search-container mb-10">
                <FontAwesomeIcon className="filter-icon mr-10" icon={faFilter} />
                <div className="filters-container">
                  {filters &&
                    Array.from(filters).map((filter, indx) => (
                      <div key={`flr-${indx}`} className="mr-10">
                        <ReactFilter
                          title={filter.key}
                          identifier={filter.key}
                          options={filter.value}
                          resetWatcher={filterVersion}
                          onSelectionChange={handleFilterChange}
                        />
                      </div>
                    ))}
                </div>

                <div className="search-input-containter">
                  <input
                    value={searchInput}
                    onChange={handleSearch}
                    onKeyDown={handleEnterSearch}
                    className="round-search-input"
                    style={{ fontSize: 12 }}
                    placeholder="Buscar por código o nombre"
                  />
                  {searchInput === '' && (
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      className="search-icon"
                      style={{ marginTop: -1 }}
                    />
                  )}
                  {searchInput && (
                    <div
                      title="Limpiar texto"
                      onClick={resetReactFilters}
                      className="round-search-input-x"
                    >
                      X
                    </div>
                  )}
                </div>
              </div>

              {isAnyFilterSelected && (
                <a onClick={resetReactFilters} className="reset-filter cursor-pointer mb-20">
                  Restablecer filtros aplicados
                </a>
              )}
            </>
          )}

          <Table hover responsive>
            <thead className="table-header-gray">
              <tr>
                <th className="col-small">
                  <span className="th-header-text">CÓDIGO</span>
                </th>
                <th className="col-large">
                  <span className="th-header-text">NOMBRE DEL PRODUCTO</span>
                </th>

                {(productFilter?.byBrand || productFilter?.byCategory) && (
                  <>
                    <th className="col-small">
                      <span className="th-header-text">UNIDAD DE VENTA 1</span>
                    </th>
                    <th className="col-small">
                      <span className="th-header-text">UNIDAD DE VENTA 2</span>
                    </th>
                  </>
                )}

                {!productFilter?.byCategory && (
                  <th className="col-large">
                    <span className="th-header-text">MARCA</span>
                  </th>
                )}

                {!productFilter?.byBrand && (
                  <th className="col-large">
                    <span className="th-header-text">CATEGORÍA</span>
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {productData && productData.length > 0 ? (
                productData.map((model, index) => (
                  <tr key={index}>
                    <td
                      className="table-body-cell td-text-limited-space"
                      data-label="Código:"
                      id={model.id}
                      onClick={showModel}
                    >
                      {model.db_ref}
                    </td>
                    <td
                      className="table-body-cell"
                      data-label="Nombre del Producto:"
                      id={model.id}
                      onClick={showModel}
                    >
                      {model.name}
                    </td>

                    {(productFilter?.byBrand || productFilter?.byCategory) && (
                      <>
                        <td className="table-body-cell">{model.packages[0]?.unit || '-'}</td>
                        <td className="table-body-cell">{model.packages[1]?.unit || '-'}</td>
                      </>
                    )}

                    {!productFilter?.byCategory && (
                      <td className="td-text-limited" id={model.id} onClick={showModel}>
                        {model.brand?.description || 'SIN ASIGNAR'}
                      </td>
                    )}

                    {!productFilter?.byBrand && (
                      <td className="td-text-limited" id={model.id} onClick={showModel}>
                        {model.category?.description || 'SIN ASIGNAR'}
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="td-text-limited" colSpan="6">
                    No hay resultados
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {pagination.total_pages > 1 && (
        <nav className="index-table" onClick={handlePaginationClick}>
          <Pagination
            current_page={pagination.current_page}
            total_pages={pagination.total_pages}
          />
        </nav>
      )}
    </>
  )
}

export default ProductIndexView
